import {
  Box,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  SelectChangeEvent,
} from '@mui/material'
import { ReactNode, FC } from 'react'

interface SelectFieldProps {
  name: string
  id: string
  labelId: string
  label: string
  value: string
  onChange: (event: SelectChangeEvent) => void
  onBlur: (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
  error?: string | boolean
  inputProps?: { [key: string]: string }
  disabled?: boolean
  children: ReactNode
}

const SelectField: FC<SelectFieldProps> = ({
  name,
  id,
  labelId,
  label,
  value,
  onChange,
  onBlur,
  error,
  inputProps,
  disabled,
  children,
}) => (
  <Box minWidth={250} margin={1}>
    <FormControl fullWidth required>
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select
        name={name}
        id={id}
        labelId={labelId}
        label={label}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        inputProps={inputProps}
        error={Boolean(error)}
        data-testid={`${name}-select-field`}
      >
        {children}
      </Select>
      {error && (
        <FormHelperText data-testid={`${name}-error`} error>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  </Box>
)

export default SelectField
